import { CastAudioVariantIcon } from './CastAudioVariantIcon';

/**
 * author: Colton Wiscombe
 * id 38E64DD7-18F9-4D85-9D62-023BDA44F642
 * name cast-audio-variant
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cast-audio-variant.svg
 * tags
 */
export const AppleAirplayIcon = CastAudioVariantIcon;
export default AppleAirplayIcon